<template>
  <div>
    <!-- Product and Warranty Details -->
    <b-row class="mb-3 mt-4">
      <b-col>
        <p class="text-dark font-size-h5 font-weight-bold mb-3">Thông tin sản phẩm và bảo hành</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3">
        <b-form-group>
          <label>Cửa hàng tiếp nhận</label>
          <treeselect
            :options="optionStores"
            :multiple="false"
            placeholder="Chọn cửa hàng"
            retryText="Thử lại..."
            retryTitle="Nhấp thử lại"
            loadingText="Đang tải..."
            noResultsText="Không có kết quả"
            :match-keys="['label', 'shortName']"
            :value="warranty.storeId"
            @select="$emit('select-store', $event)"
            :disabled="isEditMode"
          />
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <!-- TODO REVIEW cho phép chỉnh sửa imei hay khôg-->
        <ImeiSearch
          :value="warranty.imeiCode"
          @input="$emit('update-field', 'imeiCode', $event)"
          @imei-selected="$emit('imei-selected', $event)"
          @imei-searching="isImeiSearching = $event"
          :is-edit-mode="isEditMode"
          :is-create-from-bill="isCreateFromBill"
          :required="true"
        />
      </b-col>
      <b-col cols="6">
        <b-form-group class="required-control">
          <label>Tên hàng</label>
          <Autosuggest
            :model="warranty.productName"
            :suggestions="optionProducts"
            placeholder="tên, mã sản phẩm để tìm kiếm"
            :limit="10"
            :disabled="isImeiSearching"
            @select="onSelectedProduct"
            @change="onInputChangeProduct"
            suggestionName="productName"
          >
            <template #custom="{ suggestion }">
              <div>
                <span>{{ suggestion.item.productName }}</span>
              </div>
            </template>
          </Autosuggest>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        class="mb-4"
      >
        <WarrantyPackageInfoCard
          :warranty-product="warrantyProduct"
          :purchase-date="warranty.purchaseDate"
          :visible="!!(warranty.imeiCode && warrantyProduct?.id)"
          :show-dismiss="allowPackageDismiss"
          @dismiss="$emit('clear-package')"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3">
        <b-form-group class="required-control">
          <label>Người kiểm tra</label>
          <EmployeeSearch
            :value="inspectedByEmployeeName"
            :employee-id="warranty.inspectedByEmployeeId"
            :store-id="warranty.storeId"
            placeholder="Tên hoặc mã nhân viên"
            @employee-selected="$emit('employee-selected', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col
        v-if="showExpectedReturnDate"
        cols="3"
      >
        <b-form-group class="required-control">
          <label>Ngày hẹn trả</label>
          <date-picker
            placeholder="Chọn ngày hẹn trả"
            class="form-control form-control-sm"
            :config="dpConfigs.datetime"
            :value="warranty.expectedReturnDate"
            @input="$emit('update-field', 'expectedReturnDate', $event)"
          ></date-picker>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group>
          <label>Ngày bán</label>
          <date-picker
            placeholder="Chọn ngày bán"
            class="form-control form-control-sm"
            :config="dpConfigs.date"
            :value="warranty.purchaseDate"
            @input="$emit('update-field', 'purchaseDate', $event)"
            :disabled="isCreateFromBill"
          ></date-picker>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group>
          <label class="font-weight-bold">Số lần quay lại</label>
          <b-form-input
            size="sm"
            :value="warranty.returnCount"
            disabled
            type="number"
            min="0"
          ></b-form-input>
        </b-form-group>
    </b-col>
    </b-row>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import EmployeeSearch from '@/view/components/common/EmployeeSearch.vue'
import ImeiSearch from './ImeiSearch.vue'
import WarrantyPackageInfoCard from './WarrantyPackageInfoCard.vue'
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue'
import ApiService from '@/core/services/api.service'
import debounce from 'debounce'

export default {
  name: 'WarrantyProductWarrantyInfoSection',
  components: {
    Treeselect,
    EmployeeSearch,
    ImeiSearch,
    WarrantyPackageInfoCard,
    Autosuggest,
  },
  props: {
    warrantyProduct: {
      type: Object,
      default: () => ({}),
    },
    warranty: {
      type: Object,
      required: true,
    },
    optionStores: {
      type: Array,
      default: () => [],
    },
    inspectedByEmployeeName: {
      type: String,
      default: '',
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    isCreateFromBill: {
      type: Boolean,
      default: false,
    },
    dpConfigs: {
      type: Object,
      required: true,
    },
    showExpectedReturnDate: {
      type: Boolean,
      default: true,
    },
    allowPackageDismiss: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      optionProducts: [],
      isImeiSearching: false,
    }
  },
  methods: {
    onInputChangeProduct: debounce(function (text) {
      if (!text) {
        this.optionProducts = []
        this.$emit('update-field', 'productName', '')
        this.$emit('update-field', 'productId', null)
        return
      }

      this.$emit('update-field', 'productName', text)
      this.$emit('update-field', 'productId', null)

      const params = {
        searchProduct: text.trim(),
        typeSearch: 1,
        isSmartSearch: true,
      }

      ApiService.query('productSearch/search-by-type', { params })
        .then((response) => {
          this.optionProducts = response.data.data || []
        })
        .catch((error) => {
          this.optionProducts = []
        })
    }, 300),
    onSelectedProduct(suggestion) {
      if (suggestion && suggestion.item) {
        this.$emit('product-selected', {
          productName: suggestion.item.productName,
          productId: suggestion.item?.productId ?? null,
        })
      }
    },
  },
}
</script>

